module.exports = __webpack_public_path__ + "img/excellence-icon.551a43b7.png";